// export const apiPath = "http://localhost:8888/api/";
// export const apiPath = "https://truthwall-backend.herokuapp.com/api/";
export const apiPath = "https://truthwall-back-prod-truthwall-kqxqgo.mo1.mogenius.io/api/";